import { useMutation } from "@tanstack/react-query";
import { createTimeEntry } from "../api/timeEntryApi";

// Registra una imputación de horas general o de horas faltantes (POST time-entry).
export const useCreateTimeEntry = () =>
  useMutation({
    mutationFn: createTimeEntry,
  });
